<template>
  <div class="bg-muted rounded-sm px-3 py-2 mt-0.5 text-white sm:flex">
    <div class="mb-6 sm:mb-0 sm:w-7/12 sm:px-6">
      <h3 class="uppercase">
        Job Details
      </h3>
      <p class="text-xs font-bold">Required Fields *</p>
      <div>
        <xn-input
          v-model="providedMaterials"
          :v-tooltip-prop="'Check this box if you are providing your own materials.'"
          class="w-full"
          label="I am providing my own materials."
          type="checkbox"
        />
      </div>
      <xn-input
        v-model="job.material"
        :v-tooltip-prop="materialTooltipText"
        class="w-full"
        label="Material"
        placeholder="Choose Material"
        :options="materialOptions.filter(material => {
          if (providedMaterials) {
            return material.name.includes('Customer Provided')
          }
          else {
            return !material.name.includes('Customer Provided')
          }
        })"
        type="select"
        :required="true"
      />
      <xn-input
        v-if="job.material === otherMaterial"
        v-model="job.params.material"
        :v-tooltip-prop="'Enter material, thickness, and whether you are providing the material yourself, or if APROE should include it in your order.'"
        class="w-full"
        label="Other Material"
        placeholder="Enter Material"
        type="text"
        :required="job.material === otherMaterial"
      />
      <xn-input
        v-model="job.params.scale"
        :v-tooltip-prop="'Enter the measurement unit used in your file.'"
        class="w-full"
        label="Units"
        placeholder="Choose Units"
        :options="unitOptions"
        type="select"
        :required="true"
      />
      <xn-input
        v-model="job.params.times_cut"
        :v-tooltip-prop="'Enter the number of times you want the same file to be cut. Nesting design will save on materials!'"
        class="w-full"
        label="Number of times the file should be cut"
        sub-label="Learn how to nest designs to save on materials"
        type="number"
        :required="true"
        min="1"
      />
      <div class="w-full flex justify-evenly">
        <xn-input
          :id="index + 'taper'"
          v-model="job.params.taper_compensation"
          info-url="https://aproe.com/waterjet-faq/"
          label="Use Taper Compensation"
          :no-placeholder="true"
          type="checkbox"
          :disabled="job.params.axis_5"
        />
        <xn-input
          :id="index + '5-axis'"
          v-model="job.params.axis_5"
          info-url="https://aproe.com/waterjet-faq/"
          label="5-Axis Cut"
          :no-placeholder="true"
          type="checkbox"
        />
      </div>
    </div>

    <div class="sm:w-5/12 sm:px-6">
      <aproe-file-input
        :file-types="fileTypes"
        :required="true"
        @new-file-added="handleNewFile"
      />
    </div>
  </div>
</template>
<script>
import XnInput from '../components/primitives/XnInput.vue'
import AproeFileInput from '../components/AproeFileInput.vue'

export default {
  name: 'JobForm',
  components: { XnInput, AproeFileInput },
  props: {
    index: { required: true, type: Number }, // @marcus there was a Vue Warn for this prop being passed as a Number instead of String, so I thought I'd change it here and point it out to you in case it would break something
    job: { required: true, type: Object },
    materialOptions: { type: Array, default: () => [] },
    unitOptions: {
      type: Array,
      default: () => [
        /*{id:1, name:'inch'}, {id:0.03937007874, name:'millimeter'}*/
      ],
    },
  },
  data () {
    return {
      // this is a way to get those double quotes around "Other" into the tooltip
      // Vue kept seeing the terminated attribute value even with escaped qutoes (\") in the value
      materialTooltipText: 'Select one of our stock materials or select "Other" and enter required material.',
      providedMaterials: false
    }
  },
  computed: {
    otherMaterial () {
      const other = this.materialOptions.find(
        material => material.name === 'other'
      )
      return other ? String(other.id) : ''
    },
    fileTypes () {
      if (this.job.params.axis_5) {
        return ['.STP', '.stp', '.STEP', '.step']
      } else {
        return ['.dxf', '.DXF']
      }
    },
  },
  methods: {
    handleNewFile (file) {
      this.job.filename = file?file.name :null
      this.job.file = file
    },
  },
}
</script>
